(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySocialNetworkInfoControllerCustom', CompanySocialNetworkInfoControllerCustom);

    CompanySocialNetworkInfoControllerCustom.$inject = ['$rootScope', '$scope', '$state', 'CompanySocialNetworkInfo', 'CompanySocialNetworkInfoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'CompanySocialNetworkCustom', '$translate', '$translatePartialLoader', 'PackageFeatureListCustom', 'Principal'];

    function CompanySocialNetworkInfoControllerCustom($rootScope, $scope, $state, CompanySocialNetworkInfo, CompanySocialNetworkInfoSearch, ParseLinks, AlertService, pagingParams, paginationConstants, CompanySocialNetworkCustom, translate, translatePartialLoader, PackageFeatureListCustom, Principal) {
        var vm = this;

        vm.save = save;
        vm.companySocialNetworkInfoList = null;
        vm.scope = $scope;
        vm.findClass = findClass;
        vm.placeHolder = placeHolder;
        vm.isDisabled = isDisabled;
        vm.hasWhatsAppFeature = false;


        vm.okModal = okModal;
        vm.closeModal = closeModal;


        loadAll();

        function loadAll() {

            translatePartialLoader.addPart('companySocialNetworkInfo');
            translatePartialLoader = translate.refresh();

            $rootScope.$broadcast('hideNavBar');

            hasWhatsAppFeature();


            CompanySocialNetworkCustom.getCompanySocialNetwork().query(onSuccess, onError);

            function onSuccess(data, headers) {

                vm.companySocialNetworkInfoList = {};
                vm.companySocialNetworkInfoList.companySocialNetworkInfos = data;
                if (vm.companySocialNetworkInfoList.companySocialNetworkInfos == null || vm.companySocialNetworkInfoList.companySocialNetworkInfos == 0) {
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos = [];
                    // add telegram
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 1,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "TELEGRAM",
                                title: "تلگرام",
                                url: ""
                            }
                        }
                    )

                    // add instagram
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 2,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "INSTAGRAM",
                                title: "اینستاگرام",
                                url: ""
                            }
                        }
                    )

                    // add linkedin
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 3,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "LINKEDIN",
                                title: "لینکدین",
                                url: ""
                            }
                        }
                    )


                }
                if (vm.companySocialNetworkInfoList.companySocialNetworkInfos.length == 3) {
                    vm.companySocialNetworkInfoList.companySocialNetworkInfos.push(
                        {
                            id: null,
                            orderNumber: 4,
                            socialNetworkInfo: {
                                id: null,
                                socialNetworkType: "WHATSAPP",
                                title: "واتساپ",
                                url: ""
                            }
                        }
                    )
                }
                //vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.companySocialNetworkInfoList !== null && vm.companySocialNetworkInfoList.companySocialNetworkInfos != null && vm.companySocialNetworkInfoList.companySocialNetworkInfos.length > 0) {
                    {

                        CompanySocialNetworkCustom.saveCompanySocialNetworkList().save(vm.companySocialNetworkInfoList, onSaveSuccess, onSaveError);
                    }

                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companySocialNetworkInfoUpdate', result);
            vm.isSaving = false;
            loadAll();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findClass(companySocialNetworkInfo) {
            return "socialNetwork" + "-" + companySocialNetworkInfo.socialNetworkInfo.socialNetworkType;
        }

        function placeHolder(companySocialNetworkInfo) {
            var type = companySocialNetworkInfo.socialNetworkInfo.socialNetworkType;
            if (type == 'WHATSAPP' && !vm.hasWhatsAppFeature) {
                return translate.instant('feature-info.whatsAppSupport');
                ;
            } else
                return translate.instant('tikonApp.companySocialNetworkInfo.' + type + '-placeHolder');


        }

        function isDisabled(companySocialNetworkInfo) {
            var type = companySocialNetworkInfo.socialNetworkInfo.socialNetworkType;
            if (type == 'WHATSAPP' && !vm.hasWhatsAppFeature)
                return true;

            return false;
        }

        function hasWhatsAppFeature() {

            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                vm.hasWhatsAppFeature = Principal.hasSpecialFeatureAccess('whatsAppSupport');
            })

        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }
    }
})();
